
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069-1774.804a1.271 1.271 0 01.5.1 1.362 1.362 0 01.444.322l6.986 7.126a1.159 1.159 0 01.332.84 1.218 1.218 0 01-.156.615 1.2 1.2 0 01-.436.44 1.152 1.152 0 01-.6.166 1.207 1.207 0 01-.879-.381l-6.191-6.367-6.191 6.371a1.186 1.186 0 01-.879.381 1.144 1.144 0 01-.605-.166 1.2 1.2 0 01-.586-1.055 1.142 1.142 0 01.342-.84l6.973-7.129a1.253 1.253 0 01.439-.322 1.307 1.307 0 01.507-.101z"}})])])
          )
        }
      }
    